module.exports = __webpack_public_path__ + "static/media/03.686afe49.jpg";